import React from 'react';
import type { CommentStateFlagProps } from 'types';
import { CommentStateGreenIcon, CommentStateRedIcon } from './elements';

const CommentStateFlag = ({ state }: CommentStateFlagProps) => {
  switch (state) {
    case 'confirmed':
    case 'resolved':
      return (
        <CommentStateGreenIcon
          aria-label="Confirmed"
          type="CheckmarkFilled"
          size={18}
        />
      );

    case 'rejected':
      return (
        <CommentStateRedIcon
          aria-label="Rejected"
          type="WarningFilled"
          size={18}
        />
      );
    default:
      return null;
  }
};

export default CommentStateFlag;
